import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

function BSc() {
  useEffect(() => {
    window.location.href = 'https://www.researchgate.net/publication/395107374_Algebraic_Logic_of_Secrets';
  }, []);

  return (
    <Helmet>
      <title>ojee / BSc</title>
      <meta name="description" content="Omar Gamal's BSc thesis / Algebraic Logic of Secrets." />
      <link rel="canonical" href="https://ojee.net/bsc" />
    </Helmet>
  );
}

export default BSc;
